<script>
import lazyLoadComponent from '@router/lazyload-component'
import { formatGetTime } from '@utils/format-date'
import { merchantUserComputed, checkInComputed } from '@state/helpers'
import { messageStore, messageDelete } from '@utils/message'
import { notification } from '@utils/notification'

const initData = () => {
  return {
    avatar: '',
    name: '',
    title: '',
    phoneCode: '+886',
    phoneNumber: '',
    specialty: '',
    certificate: '',
    description: '',
    secretCode: '',
    secretCodeConfirm: '',
    takeOfficeDate: '',
    leaveOfficeDate: '',
    block: 0,
    maxCollision: 1,
    storeIds: [],
    serviceCategoryIds: [],
    productPriceIds: [],
    userGroups: [],
    userGroupIds: [],  // 帳號權限
    userGroupStoreIds: [],  // 分店 -> 當userGroupIds includes 12 此欄位必填
    // customerLimit: 1,
  }
}

const formatToFormData = ({ email, password = '', passwordConfirm = '', ...restData }) => {
  return {
    ...restData,
    account: email,
    secretCode: password,
    secretCodeConfirm: passwordConfirm,
  }
}

const formatSubmitData = ({ account, secretCode, secretCodeConfirm, ...restData }) => {
  return {
    ...restData,
    email: account,
    password: secretCode,
    passwordConfirm: secretCodeConfirm,
  }
}

export default {
  components: {
    BaseUpload: () => lazyLoadComponent(import('@components/BaseUpload')),
    CountryCodePicker: () => lazyLoadComponent(import('@components/CountryCodePicker')),
    ScheduleStaffServiceForm: () => lazyLoadComponent(import('@components/ScheduleStaff/ScheduleStaffServiceForm')),
    ScheduleStaffRoleForm: () => lazyLoadComponent(import('@components/ScheduleStaff/ScheduleStaffRolePermission')),
    Step2Info: () => lazyLoadComponent(import('@components/ScheduleStaff/Step2Info')),
    Step3Account: () => lazyLoadComponent(import('@components/ScheduleStaff/Step3Account')),
  },
  props: {
    defaultValue: {
      type: Object,
      default: () => initData(),
    },
    type: {
      type: String,
      default: 'new',
    },
    accessType: {
      type: String,
      default: '',
    },
    accountId: {
      type: Number,
      default: 0,
    },
    isSpace: {
      type: Boolean,
      default: false
    },
    fetchTypes: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      tryingStore: false,
      submitData: formatToFormData(Object.assign(initData(), this.defaultValue)),
      endDatePickerOptions: {
        disabledDate: (time) => {
          // check String or Date Object
          const selectedStartDate = this.submitData.takeOfficeDate instanceof Object ? this.submitData.takeOfficeDate : new Date(this.submitData.takeOfficeDate)
          return time < selectedStartDate
          // 下面是限定一年以後不給點選，先拔掉
          // const limitWith365Days = selectedStartDate.getTime() + 3600 * 1000 * 24 * 365
          // return time < selectedStartDate || time.getTime() >= limitWith365Days
        },
      },
      activeTab: this.accessType === 'employee' ? '2' : '1',
      passwordVisible: false,
      repasswordVisible: false,
      passwordEditable: false,
      allUserGroups: [],
      loadingStatus: false, // loading 狀態
      checkedPwd: false, // 確認變更密碼
      showCheckBox: false, // 看要不要顯示變更密碼按鈕
      appStyle: process.env.VUE_APP_BUILD_MODE === 'admin-app-build',
    }
  },
  computed: {
    ...merchantUserComputed,
    ...checkInComputed,
    isEditMode() {
      return this.defaultValue.id
    },
    hasAdminPermission() {
      if (this.defaultValue.userGroupIds) {
        return this.defaultValue.userGroupIds.includes(7)
      }

      const userGroupIds = this.defaultValue.userGroups.map(({ id }) => id)
      return userGroupIds.includes(7)
    },
    hasBranchPermission() {
      return this.submitData.userGroupIds.includes(12) && this.submitData.userGroupStoreIds
    },
    /**
     * @description 因為怕使用者直接點擊頁面，跳過設定，所以新建時，就要擋其點選tab Name
     */
    clickTab() {
      if (this.isEditMode || (this.submitData.title && this.submitData.title.length > 0)) return true
      if (this.activeStep === 1 && !this.isEditMode) {
        return false
      } else {
        return true
      }
    }
  },
  watch: {
    defaultValue: 'updateSubmitData',
    activeTab(nvl, ovl) {
    }
  },
  async created() {
    this.allUserGroups = await this.$store.dispatch('merchant/fetchUserGroups')
    if (this.submitData.userGroupIds.length === 0) {
      this.submitData.userGroupIds = this.submitData.userGroups ? [...this.submitData.userGroups.map(item => item.id)] : []
    }
    this.submitData.phoneCode = '+886'

  },
  mounted() {
    if (!this.isEditMode || this.accountId !== 0) {
      this.passwordEditable = true
    }
    this.showPwdCheck()
    if (this.accessType === 'employee') this.activeTab = '2'
  },
  methods: {
    /**
     * @description 點擊tab
     */
    handleClick(tab, event) {
      this.activeTab = tab.name
    },
    showPwdCheck() {
      // 完全新增
      if (!this.submitData.account) {
        this.showCheckBox = false
        this.checkedPwd = true
        return
      }
      // 從角色列表新增
      if (!this.defaultValue.id && this.submitData.account) {
        this.showCheckBox = true
        this.checkedPwd = false
        return
      }
      // 等同編輯角色
      if (this.defaultValue.id.length > 0 && this.submitData.account) {
        this.showCheckBox = true
        return
      }
    },
    /**
     * @description 因為會有修改角色直接儲存的問題，所以這邊要做驗證
     */
    validateSave() {
      let validate = true
      if (this.submitData.userGroupIds.includes(7)) return validate
      if (this.submitData.userGroupIds.includes(12) && this.submitData.userGroupStoreIds.length === 0) {
        this.$message({
          message: '請至基本資訊設定分店',
          type: 'error',
        })
        validate = false
      }
      return validate
    },
    /**
     * @description 美容師畫面儲存
     */
    async tryToStoreEmployee() {
      await this.$refs.form.validate()
      let submitData = Object.assign({}, this.submitData)
      submitData = formatSubmitData(submitData)
      await this.$store.dispatch('schedule/storeStaff', submitData)
      messageStore('edit')
      this.emitStore()
    },
    async tryToStore() {
      if (this.accessType === 'employee') {
        await this.tryToStoreEmployee()
        return
      }
      if (this.activeTab === '2') {
        await this.$refs.Step2Info.$refs.form.validate()
      }
      if (this.activeTab === '4') {
        if (!this.$refs.step2.validateServiceTree()) return
        await this.$refs.step2.$refs.form.validate()
      }
      if (!this.validateSave()) return
      try {
        let submitData = {}
        if (!this.$refs.step2) {
          submitData = Object.assign({}, this.submitData, { 
            type: this.fetchTypes[0]
          })
        } else {
          const result = this.$refs.step2.filterSubmitData
          submitData = Object.assign({}, this.submitData, result, { 
            type: this.fetchTypes[0]
          })
        }
        submitData = formatSubmitData(submitData)
        this.tryingStore = true
        if (!this.isEditMode) {
          // 新增mode
          if (this.accountId) {
            const accountUser = await this.$store.dispatch('schedule/sendLinkUser', { userId: this.accountId })
            submitData.id = accountUser.id
          }
          const newStaff = await this.$store.dispatch('schedule/storeStaff', submitData)
          messageStore('add')
          notification('排班人員', '排班', 'schedule')
          this.emitStore(newStaff)
        } else {
          // 修改mode
          await this.$store.dispatch('schedule/storeStaff', submitData)
          await this.$store.dispatch('auth/fetchAccess') // 因為有可能分店管理者自己改分店，所以這邊重打一次權限
          messageStore('edit')
          this.emitStore()
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.tryingStore = false
      }
    },
    emitStore(newStaff = '') {
      this.$emit('store', newStaff)
      this.emitClose()
    },
    emitClose() {
      this.$emit('close')
      // this.$refs.form.resetFields()
    },
    updateSubmitData() {
      this.submitData = formatToFormData(Object.assign({}, this.defaultValue))
    },
    async toNext() {
      try {
        let result = true
        if (this.activeTab === '1') {
          result = await this.$refs.roleForm.validateSelf()
        }
        if (this.activeTab === '2') {
          result = await this.$refs.Step2Info.$refs.form.validate()
        }
        if (this.activeTab === '3') {
          result = await this.$refs.Step3Account.$refs.form.validate()
        }
        if (!result) return
        let stateTab = +this.activeTab
        this.activeTab = `${++stateTab}`
      } catch (error) {
        console.error(error.message)
      }

    },
    async beforeTabSwitch(activeName, oldActiveName) {
      if (oldActiveName === '1') {
        await this.$refs.roleForm.validateSelf()
      }
      if (oldActiveName === '2') {
        await this.$refs.Step2Info.$refs.form.validate()
      }
      if (oldActiveName === '3') {
        await this.$refs.Step3Account.$refs.form.validate()
      }
      if (oldActiveName === '4') {
        await this.$refs.step2.$refs.form.validate()
      }
      this.activeTab = activeName
    },
    loadingStatusFunc(status) {
      this.loadingStatus = status
    },
  },
}
</script>

<template>
  <!-- 人事 -> 新增人員 -> 進來的畫面 -->
  <div
    :class="[{ isEmployeeMob: accessType === 'employee' }, $style.outPage, isEditMode ? $style.editMode : $style.createMode]">
    <!-- 右上角x按鈕 -->
    <!-- <div v-if="accessType === 'employee'" class="right-top-btn" @click="emitClose">
        <BaseIcon name="times" icon-style="fal" class="right-top-btn" />
      </div> -->
    <!-- 左邊編輯資料 -->
    <!-- <BasePageHeader v-if="accessType === 'employee'" title="編輯資料" /> -->
    <el-tabs v-model="activeTab" :type="'border-card'" :before-leave="beforeTabSwitch" stretch class="isStyleBase "
      :class="[$style.pageActive, { 'isStyleNoBoxShadow': accessType === 'employee' }, appStyle ? $style['appStyleTop'] : '', { [$style['isStyleEmployeeCustom']]: accessType === 'employee' }]">
      <el-tab-pane v-if="accessType !== 'employee' && allUserGroups.length > 0" key="0" label="選擇角色"
        name="1"></el-tab-pane>
      <el-tab-pane key="1" label="基本資訊" name="2" :disabled="!clickTab"></el-tab-pane>
      <el-tab-pane key="2" label="帳號密碼" name="3" :disabled="!clickTab"></el-tab-pane>
      <el-tab-pane v-if="accessType !== 'employee'" key="3" label="服務項目" name="4" :disabled="!clickTab"></el-tab-pane>
    </el-tabs>
    <div v-if="accessType === 'employee'" class="returnClass" @click="emitClose">
      <BaseIcon icon-style="fal" name="chevron-down" style="transform:rotate(90deg);" />
      <el-button class="is-no-style"> 返回</el-button>
    </div>
    <!-- 一套的返回按鈕 -->
    <div v-if="accessType !== 'employee'" :class="$style.staffModi" style="padding:20px 16px">
      <el-page-header :content="isEditMode ? '編輯人員' : '新增人員'" @back="$emit('goBack')"></el-page-header>
    </div>
    <div v-show="activeTab === '1'" :class="{ [$style['activeTabStyle']]: accessType !== 'employee' }">
      <ScheduleStaffRoleForm ref="roleForm" v-model="submitData" :all-user-groups="allUserGroups"
        :permission="hasBranchPermission" :cached-products="cachedProducts" :default-value="defaultValue" />
    </div>
    <div v-show="activeTab === '2'" :class="{ [$style['activeTabStyle']]: accessType !== 'employee' }">
      <Step2Info ref="Step2Info" v-model="submitData" :access-type="accessType" :has-admin-permission="hasAdminPermission"
        :default-value="defaultValue" :is-space="isSpace" class="bg-white" />
    </div>
    <div v-show="activeTab === '3'" :class="{ [$style['activeTabStyle']]: accessType !== 'employee' }">
      <Step3Account ref="Step3Account" v-model="submitData" :access-type="accessType"
        :has-admin-permission="hasAdminPermission" :default-value="defaultValue" class="bg-white" />
    </div>
    <div v-show="activeTab === '4'" :class="{ [$style['activeTabStyle']]: accessType !== 'employee' }">
      <ScheduleStaffServiceForm ref="step2" v-model="submitData" :default-value="defaultValue" :class="$style.pageContent"
        class="bg-white" @loadingStatus="loadingStatusFunc" />
    </div>
    <div v-if="accessType === 'employee'" class="employeeMobBtn">
      <el-button class="is-round" :loading="tryingStore" @click="emitClose">取消</el-button>
      <el-button class="is-round" type="primary" :loading="tryingStore" @click="tryToStore">儲存</el-button>
    </div>
    <div v-else :class="[$style.footer, { isSchedule: accessType === 'schedule' }]">
      <el-button class="is-round" :loading="tryingStore" @click="emitClose">{{ isEditMode ? '取消編輯' : '取消' }}</el-button>
      <el-button v-if="isEditMode" class="is-round" type="primary" :loading="tryingStore" @click="tryToStore"
        :disabled="loadingStatus">儲存編輯
      </el-button>
      <el-button v-if="activeTab !== '4' && !isEditMode" class="is-round" type="primary" :loading="tryingStore"
        @click="toNext">下一頁
      </el-button>
      <el-button v-if="activeTab === '4' && !isEditMode" :disabled="loadingStatus" class="is-round" type="primary"
        :loading="tryingStore" @click="tryToStore">{{ isEditMode ? '儲存編輯' : '創建' }}
      </el-button>
    </div>
  </div>
</template>
<style lang="scss" module>
@import '@src/design/layout_detail_steps.scss';

.thisPageCus {
  :global {
    .el-tabs__content {
      padding-top: 0;
    }
  }
}

:global {
  .isSchedule {
    position: static;
    width: 100%;
    left: 0;
    box-shadow: none;
    margin-top: 10px;
  }

  .el-tabs--border-card>.el-tabs__content {
    // padding-bottom: 0;
  }
}

:global {
  .el-page-header {
    align-items: center;
    font-size: 22px;
  }

  .el-page-header__left {
    border: 1px solid $color-border-for-bg-white;
    border-radius: $border-radius;
    padding: 12px 24px;
  }
}

.activeTabStyle {
  background-color: $color-body-bg;
  padding: 20px;
}

.staffModi {
  padding: 20px 16px 0;

  :global {
    .el-page-header__left {
      background-color: white;
    }
  }
}

.pageActive {
  padding: 0px;

  :global {
    .el-tabs__content {
      // padding-bottom: 0;
      // border: 1px solid red;
    }

    .el-page-header__left {
      background-color: white;
    }

    .el-tabs__header>.el-tabs__nav-wrap .el-tabs__nav .is-active {
      border-bottom: 2px solid $color-primary !important;
    }

    .el-tabs__item {
      padding-left: 0 !important;
      padding-right: 0 !important;
    }
  }
}

.outPage {
  margin: auto -20px;

  :global {
    .returnClass {
      display: flex;
      align-items: center;
      justify-content: flex-start;

      :global {
        .el-button {
          margin-left: 8px;
        }
      }

      @include max-md {
        padding-top: 37px;
        padding-left: 20px;
      }

      @include max-sm {
        padding-top: 37px;
        padding-left: 20px;
      }
    }

    .employeeMobBtn {
      display: flex;
      justify-content: center;
      padding: 20px;

      :global {
        .el-button {
          width: 100%;
          // @include max-md {
          //   width: 40%;
          // }
        }
      }
    }
  }

  &:global {
    &.isEmployeeMob {
      margin: auto 0;
      padding-bottom: 8rem;
      background: #fff;
    }
  }

  &.editMode {
    margin-top: -30px;
    // position: sticky;
  }

  &.createMode {
    margin-top: -20px;
  }
}

.pageBaseInfo {
  background-color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  // padding: 20px;
  :global {
    .basicInfoForMainPart {
      padding-left: 20px;
    }

    .imgPlacement {
      display: flex;
      justify-content: center;
    }
  }
}

.allPageStyle {
  padding: 20px 20px 100px;
  background-color: white;

  :global {
    .itemTitle {
      font-size: 14px;
      color: $color-secondary;
      font-weight: bold;
    }

    .smallAfterExitDay {
      :global {
        .el-form-item__label {
          &::after {
            content: '  任職結束即自動停權';
            font-size: 12px;
          }
        }
      }
    }
  }
}

.isEmployeeMob {
  margin-top: 24px;

  @include max-md {
    margin-top: 100px;
  }

  @include max-lg {
    margin-top: 100px;
  }

  @include max-sm {
    margin-top: 100px;
  }
}

.normalTop {
  top: 70px !important;
}

.appStyleTop {
  top: 88px !important;
}

.isStyleEmployeeCustom {
  z-index: 1 !important;
  margin-left: -32px;
  margin-right: -32px;
}

.contextMargin {
  margin-top: 88px;
}
</style>

